import React from "react";

const Layout = ({ sidebarElement, children }) => {
	return (
		<>
			<div className="container">
				<main className="main">
					{sidebarElement && (
						<aside className="aside">
							<div className="sidebar-content">{sidebarElement}</div>
						</aside>
					)}
					<article className="article">{children}</article>
				</main>
			</div>
		</>
	);
};

export default Layout;
